import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90c39602"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item special-tag-more" }, "更多", -1))
const _hoisted_3 = { class: "name" }
const _hoisted_4 = ["data-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_view = _resolveComponent("image-view")!
  const _component_grid_view = _resolveComponent("grid-view")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "v-row list-view",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onListViewClicked && _ctx.onListViewClicked(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTags, (tag) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", {active: _ctx.specialTagParam.id === tag.id}]),
          key: tag.id,
          "data-id": tag.id
        }, _toDisplayString(tag.name), 11, _hoisted_1))
      }), 128)),
      _hoisted_2
    ]),
    _createVNode(_component_grid_view, {
      style: {"margin-top":"1em"},
      data: _ctx.specialList,
      "cell-widths": "repeat(auto-fit, 13em)",
      "cell-height": 234,
      onInfiniteScroll: _ctx.loadData
    }, {
      default: _withCtx(({item}) => [
        _createVNode(_component_image_view, {
          modelValue: item.cover,
          "onUpdate:modelValue": ($event: any) => ((item.cover) = $event),
          defaultValue: "icon/special.png"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)
      ]),
      _: 1
    }, 8, ["data", "onInfiniteScroll"]),
    _createVNode(_component_modal, {
      modality: "",
      title: "全部分类",
      width: "70%",
      height: "60%",
      visible: _ctx.tagModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tagModal) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (item, _index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: _index }, [
            _createTextVNode(_toDisplayString(item.title) + " ", 1),
            _createElementVNode("div", {
              class: "v-row list-view",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onListViewClicked && _ctx.onListViewClicked(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (tag, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["item", {active: _ctx.specialTagParam.id === tag.id}]),
                  key: index,
                  "data-id": tag.id
                }, _toDisplayString(tag.name), 11, _hoisted_4))
              }), 128))
            ])
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}